export const baseStrapiGetPrevNextQueryObject = <QueryBySlugPrevNextOptions>(filterValue: string, filter = '$lt', sortDir = 'asc') => {
  return {
    filter,
    filterValue,
    sortDir,
    locale: baseI18nGetActiveIso()
  }
}
